export default function getWeekdaysForTerm(start, end) {
    const days = ["sun", "mon", "tue", "wed", "thu", "fri", "sat"];

    const startDate = new Date(start);
    const endDate = new Date(end);

    endDate.setDate(endDate.getDate() + 1);

    const daysOfWeek = [];

    let i = 0;

    while (i < 7 && startDate < endDate) {
        daysOfWeek.push(days[startDate.getDay()]);
        startDate.setDate(startDate.getDate() + 1);
        i += 1;
    }

    return daysOfWeek;
}
